//酒店导航菜单
export default [
    // {label:'发确认单',iconClass:'icon-dingdan',powerArr:[222],path:{name:'OrderPost',query:{orderConfirm:true,modify:true,orderConfirmSend:true}}},
    // {label:'待处理', iconClass:'icon-shenpizhong', powerArr:[139],path:{name:'OrderHandle',query:{page:1,orderStatus:'0',orderType:3}},num:'wait_handle'},
    // {label:'待处理',iconClass:'icon-shenpizhong', powerArr:[79,222],path:{name:'OrderHandle',query:{page:1,orderStatus:'0',orderType:3}},num:'wait_handle',
    //     children:[
          
    //     ],
    // },
    // {label:'确认单',iconClass:'icon-dingdan1',powerArr:[139,261],path:{name:'HotelConfirmList',query:{page:1,orderStatus:'1',orderType:3}},num:'status_unify'},
    // {label:'订单管理',iconClass:'icon-dingdan1',powerArr:[139,261],path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'order'},
    {label:'订单管理',iconClass:'icon-dingdan1',path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'hotelOrderStatistics',
        children:[
            {label:'待报价',powerArr:[79,222],path:{name:'InquiryList',query:{page:1,orderStatus:'0',orderType:3}},num:'wait_offer'},
            {label:'已报价',powerArr:[79,222],path:{name:'Quotation',query:{page:1,orderStatus:'1',orderType:3}},num:'status_4'},
            {label:'待确认',powerArr:[79,222],path:{name:'ConfirmList',query:{page:1,orderStatus:'1',orderType:3}},num:'wait_confirm'},
            // {label:'确认单',path:{name:'HotelConfirmList',query:{page:1,orderStatus:'5',orderType:3}},num:'status_confirm'},
            {label:'订单列表',powerArr:[221,261,365,433,431,138,107,546],path:{name:'OrderLists',query:{page:1,orderStatus:'all',orderType:3}},num:'order'},
        ],
    },
    // {label:'房态日历', iconClass:'icon-rili2', powerArr:[182,301,187,306,192,443,547], path:{name:'RoomCalendar',query:{step:'3'}},num:'confirm_doing_self_handle'},
    // {label:'资料信息',
    //     iconClass:'icon-Information',
    //     children:[
    //         {label:'门店资料',powerArr:[152,268,367,231,554,555],path:{name:'StoreBasicInfo'}},
    //         {label:'房型资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupRoom',query:{step:'3'}}},
    //         {label:'会场资料',powerArr:[182,301,187,306,192,443,547], path:{name:'GroupMeeting',query:{step:'4'}}},
    //         // {label:'认证信息',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'}},
    //     ],
    // },
    {label:'发票管理',iconClass:'icon-fapiaoguanli1',powerArr:[152,268,367,231,554,555],path:{name:'InvoiceManage'}},
    {label:'财务管理',iconClass:'icon-caiwuguanli',powerArr:[152,268,367,231,554,555],path:{name:'FinancialList'},num:'treasurer_count'},
    // {label:'认证信息',
    //     iconClass:'icon-qiyerenzheng2',
    //     children:[   
    //         {label:'酒店资质',powerArr:[152,268,367,231,554,555],path:{name:'StoreCertification'},},
    //         {label:'银行卡管理',powerArr:[152,268,367,231,554,555],path:{name:'BankcardManage'}},
    //     ],
    // },
    // {label:'人事管理',
    //     iconClass:'icon-zhuce',
    //     powerArr:[],path:{name:'PositionManage'}
    //     // children:[
    //     //     {label:'职位管理',powerArr:[332,175,288,387,581],path:{name:'PositionManage'}},
    //     //     {label:'人员管理',powerArr:[337,170,293,392,582],path:{name:'StaffManage'}},
    //     // ],
    // },
    {label:'消息中心',iconClass:'icon-xiaoxi',powerArr:[],path:{name:'MsgLists',query:{msg_type:'2'}}},
    // {label:'排行榜',iconClass:'icon-icon-',powerArr:[],path:{name:'GradeManage'}},
    {label:'账号设置',iconClass:'icon-shezhi',powerArr:[],path:{name:'AccountSet'}}
]